import request from 'axios';
import {setStore} from '../util/store_util';

// 超时时间
request.defaults.timeout = 100000;

request.defaults.baseURL = getApiServer();

// 返回其他状态吗
request.defaults.validateStatus = function(status) {
  return status >= 200 && status <= 500; // 默认的
};

// 跨域请求，允许保存cookie
request.defaults.withCredentials = true;



/**
 * 获取 API 接口地址
 */
function getApiServer() {
  const globalConfig = getGlobalConfig();
  setStore('globalConfig', globalConfig);
  return globalConfig.apiServer;
}


/**
 * 获取全局配置信息
 * @returns {string}
 */
function getGlobalConfig() {
  const cfg = require('../../../../public/cfg');
  console.log(cfg);
  return cfg;
}


export default request;
